<template>
  <div class='preViewWrap'>
    <div class='preView'>
      <el-button type="primary" v-print='printGrainOption'>打印</el-button>
      <el-button type="info" @click="gotoBack">返回</el-button>
      <div id='print'>
        <div style="page-break-after:always" v-for='(item,index) in grainInfo' :key='index'>
          <div class='printHeader'>{{waterType=='hum'?'湿度':(waterType=='water'?'水分':'粮温')}}管理系统</div>
          <div class='printWareTitle'>{{item.wareName}} {{waterType=='hum'?'湿度':(waterType=='water'?'水分':'粮温')}}信息报表</div>
          <div class='printTable' v-if='item.wareType==0'>
            <div class='printTableHeader'>
              <div>单位：<span>{{waterType=='hum'?'%RH':(waterType=='water'?'%':'℃')}}</span></div>
              <div>检测时间：<span>{{item.createTime}}</span></div>
            </div>
            <div class='printTableWrap'>
              <div class='printHang'>
                <div class='tableTitle' style='border-right:none'></div>
                <div class='tableTitle'></div>
                <div v-for='event in item.mirColumn' :key='event'>第{{event}}列</div>
              </div>
              <div v-for='ind in item.mirRow' :key='ind' class='printHang'>
                <div class='tableTitle'>第{{ind}}行</div>
                <div class='tableTitle'>
                  <div v-for='layer in item.mirLayer' :key='layer'>第{{layer}}层</div>
                </div>
                <div v-for='(event,index) in item.pointList[ind-1]' :key='index'>
                  <div v-for='(ceng,num) in event' :key='num'>
                    <div v-if='waterType=="hum"'>{{ceng.hum||ceng.hum==0?ceng.hum:'--'}}{{ceng.humMark=='max'?'*':(ceng.humMark=='min'?'#':'')}}</div>
                    <div v-else-if='waterType=="water"'>{{ceng.water||ceng.water==0?ceng.water:'--'}}{{ceng.waterMark=='max'?'*':(ceng.waterMark=='min'?'#':'')}}</div>
                    <div v-else>{{ceng.value||ceng.value==0?ceng.value:'--'}}{{ceng.mark=='max'?'*':(ceng.mark=='min'?'#':'')}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class='printAvgTemp'>
              <div class='printPart'>
                <div></div>
                <div>{{waterType=='hum'?'最高湿度':(waterType=='water'?'最高水分':'最高粮温')}}</div>
                <div>{{waterType=='hum'?'最低湿度':(waterType=='water'?'最低水分':'最低粮温')}}</div>
                <div>{{waterType=='hum'?'平均湿度':(waterType=='water'?'平均水分':'平均粮温')}}</div>
                <div>{{waterType=='hum'?'':(waterType=='water'?'':'周均温')}}</div>
                <div>{{waterType=='hum'?'':(waterType=='water'?'':'内均温')}}</div>
              </div>
              <div v-if='waterType=="hum"' class='printLayerInfo'>
                <div v-for='event in item.infos' :key='event.infoId' class='printPart'>
                  <div>第 {{event.mirLayer}} 层</div>
                  <div>{{event.infoHumMax||event.infoHumMax==0?event.infoHumMax:'--'}}</div>
                  <div>{{event.infoHumMin||event.infoHumMin==0?event.infoHumMin:'--'}}</div>
                  <div>{{event.infoHumAve||event.infoHumAve==0?event.infoHumAve:'--'}}</div>
                  <div></div>
                  <div></div>
                </div>
                <div class='printPart'>
                  <div>整仓</div>
                  <div>{{item.humMax||item.humMax==0?item.humMax:'--'}}</div>
                  <div>{{item.humMin||item.humMin==0?item.humMin:'--'}}</div>
                  <div>{{item.humAve||item.humAve==0?item.humAve:'--'}}</div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <div v-else-if='waterType=="water"'>
                <div v-for='event in item.infos' :key='event.infoId' class='printPart'>
                  <div>第 {{event.mirLayer}} 层</div>
                  <div>{{event.infoWaterMax||event.infoWaterMax==0?event.infoWaterMax:'--'}}</div>
                  <div>{{event.infoWaterMin||event.infoWaterMin==0?event.infoWaterMin:'--'}}</div>
                  <div>{{event.infoWaterAve||event.infoWaterAve==0?event.infoWaterAve:'--'}}</div>
                  <div></div>
                  <div></div>
                </div>
                <div class='printPart'>
                  <div>整仓</div>
                  <div>{{item.waterMax||item.waterMax==0?item.waterMax:'--'}}</div>
                  <div>{{item.waterMin||item.waterMin==0?item.waterMin:'--'}}</div>
                  <div>{{item.waterAve||item.waterAve==0?item.waterAve:'--'}}</div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <div v-else>
                <div v-for='event in item.infos' :key='event.infoId' class='printPart'>
                  <div>第 {{event.mirLayer}} 层</div>
                  <div>{{event.tempMax||event.tempMax==0?event.tempMax:'--'}}</div>
                  <div>{{event.tempMin||event.tempMin==0?event.tempMin:'--'}}</div>
                  <div>{{event.tempAve||event.tempAve==0?event.tempAve:'--'}}</div>
                  <div>{{event.zTempAve||event.zTempAve==0?event.zTempAve:'--'}}</div>
                  <div>{{event.nTempAve||event.nTempAve==0?event.nTempAve:'--'}}</div>
                </div>
                <div class='printPart'>
                  <div>整仓</div>
                  <div>{{item.tempMax||item.tempMax==0?item.tempMax:'--'}}</div>
                  <div>{{item.tempMin||item.tempMin==0?item.tempMin:'--'}}</div>
                  <div>{{item.tempAve||item.tempAve==0?item.tempAve:'--'}}</div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <div class='printPart'>
                <div>仓温</div>
                <div>{{item.tempIn||item.tempIn==0?item.tempIn:'--'}}</div>
                <div>仓湿</div>
                <div>{{item.humidityIn||item.humidityIn==0?item.humidityIn:'--'}}</div>
                <div>气温</div>
                <div>{{item.tempOut||item.tempOut==0?item.tempOut:'--'}}</div>
                <div>气湿</div>
                <div>{{item.humidityOut||item.humidityOut==0?item.humidityOut:'--'}}</div>
              </div>
              <div class='printPart'>
                <div>仓房类型</div>
                <div>{{item.wareType==0?'平房仓':'浅圆仓'}}</div>
                <div>入仓时间</div>
                <div>{{item.dateOfIn}}</div>
              </div>
              <div class='printPart'>
                <div>粮食品种</div>
                <div>{{item.foodFariety}}</div>
                <div>实际储量</div>
                <div>{{item.storageReal}}</div>
              </div>
              <div class='printPart'>
                <div>入仓水分</div>
                <div>{{item.grainInWater}}</div>
                <div>当前水分</div>
                <div>{{item.grainWater}}</div>
              </div>
              <div class='printPart'>
                <div>检验人</div>
                <div>{{item.createBy}}</div>
                <div>保管员</div>
                <div></div>
              </div>
              <div class='printPart'>
                <div>粮情分析</div>
                <div style='flex-grow:3;flex-basis:302px'></div>
              </div>
              <div class='printPart'>
                <div class='printIdeaInfo'>粮食安危及虫害处理情况：</div>
                <div class='printIdeaInfo'>“一符四无”粮食鉴定意见：</div>
              </div>
            </div>
            <div class='printTips'>
              <div>注：#代表最小值 *代表最大值</div>
              <div>制表时间：{{item.printTime}}</div>
            </div>
          </div>
          <div class='printTable' v-else>
            <div class='printTableHeader'>
              <div>单位：<span>{{waterType=='hum'?'%RH':(waterType=='water'?'%':'℃')}}</span></div>
              <div>检测时间：<span>{{item.createTime}}</span></div>
            </div>
            <div class='printTableWrap'>
              <div class='printHang'>
                <div></div>
                <div>最高</div>
                <div>最低</div>
                <div>平均</div>
                <div v-for='event in item.mirColumn' :key='event'>第{{event}}根</div>
              </div>
              <div v-if='waterType=="hum"'>
                <div class='printHang' v-for='(info,ind) in item.infos' :key='info.infoId'>
                  <div>第 {{info.mirLayer}} 层</div>
                  <div>{{info.infoHumMax||info.infoHumMax==0?info.infoHumMax:'--'}}</div>
                  <div>{{info.infoHumMin||info.infoHumMin==0?info.infoHumMin:'--'}}</div>
                  <div>{{info.infoHumAve||info.infoHumAve==0?info.infoHumAve:'--'}}</div>
                  <div v-for='(event,index) in item.pointList[ind]' :key='index'>{{event.hum||event.hum?event.hum:'--'}}{{event.humMark=='max'?'*':(event.humMark=='min'?'#':'')}}</div>
                </div>
              </div>
              <div v-else-if='waterType=="water"'>
                <div class='printHang' v-for='(info,ind) in item.infos' :key='info.infoId'>
                  <div>第 {{info.mirLayer}} 层</div>
                  <div>{{info.infoWaterMax||info.infoWaterMax==0?info.infoWaterMax:'--'}}</div>
                  <div>{{info.infoWaterMin||info.infoWaterMin==0?info.infoWaterMin:'--'}}</div>
                  <div>{{info.infoWaterAve||info.infoWaterAve==0?info.infoWaterAve:'--'}}</div>
                  <div v-for='(event,index) in item.pointList[ind]' :key='index'>{{event.water||event.water?event.water:'--'}}{{event.waterMark=='max'?'*':(event.waterMark=='min'?'#':'')}}</div>
                </div>
              </div>
              <div v-else>
                <div class='printHang' v-for='(info,ind) in item.infos' :key='info.infoId'>
                  <div>第 {{info.mirLayer}} 层</div>
                  <div>{{info.tempMax||info.tempMax==0?info.tempMax:'--'}}</div>
                  <div>{{info.tempMin||info.tempMin==0?info.tempMin:'--'}}</div>
                  <div>{{info.tempAve||info.tempAve==0?info.tempAve:'--'}}</div>
                  <div v-for='(event,index) in item.pointList[ind]' :key='index'>{{event.value||event.value?event.value:'--'}}{{event.mark=='max'?'*':(event.mark=='min'?'#':'')}}</div>
                </div>
              </div>
            </div>
            <div class='printAvgTemp'>
              <div class='printPart'>
                <div></div>
                <div>{{waterType=='hum'?'最高湿度':(waterType=='water'?'最高水分':'最高粮温')}}</div>
                <div>{{waterType=='hum'?'最低湿度':(waterType=='water'?'最低水分':'最低粮温')}}</div>
                <div>{{waterType=='hum'?'平均湿度':(waterType=='water'?'平均水分':'平均粮温')}}</div>
              </div>
              <div class='printPart' v-if='waterType=="hum"'>
                <div>整仓</div>
                <div>{{item.humMax||item.humMax==0?item.humMax:'--'}}</div>
                <div>{{item.humMin||item.humMin==0?item.humMin:'--'}}</div>
                <div>{{item.humAve||item.humAve==0?item.humAve:'--'}}</div>
              </div>
              <div class='printPart' v-else-if='waterType=="water"'>
                <div>整仓</div>
                <div>{{item.waterMax||item.waterMax==0?item.waterMax:'--'}}</div>
                <div>{{item.waterMin||item.waterMin==0?item.waterMin:'--'}}</div>
                <div>{{item.waterAve||item.waterAve==0?item.waterAve:'--'}}</div>
              </div>
              <div class='printPart' v-else>
                <div>整仓</div>
                <div>{{item.tempMax||item.tempMax==0?item.tempMax:'--'}}</div>
                <div>{{item.tempMin||item.tempMin==0?item.tempMin:'--'}}</div>
                <div>{{item.tempAve||item.tempAve==0?item.tempAve:'--'}}</div>
              </div>
              <div class='printPart'>
                <div>仓温</div>
                <div>{{item.tempIn||item.tempIn==0?item.tempIn:'--'}}</div>
                <div>仓湿</div>
                <div>{{item.humidityIn||item.humidityIn==0?item.humidityIn:'--'}}</div>
                <div>气温</div>
                <div>{{item.tempOut||item.tempOut==0?item.tempOut:'--'}}</div>
                <div>气湿</div>
                <div>{{item.humidityOut||item.humidityOut==0?item.humidityOut:'--'}}</div>
              </div>
              <div class='printPart'>
                <div>仓房类型</div>
                <div>{{item.wareType==0?'平房仓':'浅圆仓'}}</div>
                <div>入仓时间</div>
                <div>{{item.dateOfIn}}</div>
              </div>
              <div class='printPart'>
                <div>粮食品种</div>
                <div>{{item.foodFariety}}</div>
                <div>实际储量</div>
                <div>{{item.storageReal}}</div>
              </div>
              <div class='printPart'>
                <div>入仓水分</div>
                <div>{{item.grainInWater}}</div>
                <div>当前水分</div>
                <div>{{item.grainWater}}</div>
              </div>
              <div class='printPart'>
                <div>检验人</div>
                <div>{{item.createBy}}</div>
                <div>保管员</div>
                <div>{{item.custodian}}</div>
              </div>
              <div class='printPart'>
                <div>粮情分析</div>
                <div style='flex-grow:3;flex-basis:302px'></div>
              </div>
              <div class='printPart'>
                <div class='printIdeaInfo'>粮食安危及虫害处理情况：</div>
                <div class='printIdeaInfo'>“一符四无”粮食鉴定意见：</div>
              </div>
            </div>
            <div class='printTips'>
              <div>注：#代表最小值 *代表最大值</div>
              <div>制表时间：{{item.printTime}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../axios.js'
export default {
  data(){
    return{
      grainInfo:[],
      printGrainOption:{
        id:'print',
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
        popTitle: '粮情信息报表'
      },
      waterType:''
    }
  },
  created(){
    this.getGrainInfoList();
    let waterInfo=JSON.parse(localStorage.getItem('waterInfo'));
    let waterType='';
    if(waterInfo){
      if(waterInfo.waterType){
        waterType='hum'
      }else{
        waterType='water'
      }
    }
    this.waterType=waterType
  },
  methods:{
    gotoBack(){
      this.$router.go(-1)
    },
    getGrainInfoList(){
      let params=this.$route.params;
      let info=JSON.parse(params.info);
      console.log(info)
      let data=[];
      data.push(info)
      data.forEach(item=>{
        let layer=item.mirLayer;
        let row=item.mirRow;
        let column=item.mirColumn;
        let pointList=[];
        if(item.wareType==0){
          for(let i=0;i<row;i++){
            let arr=[];
            for(let j=0;j<column;j++){
              let point=new Array(layer).fill({});
              item.details.forEach(event=>{
                if(event.mirColumn==(j+1)&&event.mirRow==(i+1)){
                  point.fill({
                    value:event.temp,
                    mark:event.mark,
                    water:event.water,
                    hum:event.hum,
                    waterMark:event.waterMark,
                    humMark:event.humMark,
                  },event.mirLayer-1,event.mirLayer)
                }
              })
              arr.push(point)
            }
            pointList.push(arr);
          }
        }else{
          let coilRule=item.coilRule.split('-');
          let array=[]
          for(let i=0;i<layer;i++){
            let n=0;
            let arr=[];
            for(let j=0;j<coilRule.length;j++){
              let point=new Array(Number(coilRule[j])).fill({});
              if(j>0){
                n+=Number(coilRule[j-1])
              }
              item.details.forEach(event=>{
                if(event.mirLayer==(i+1)&&event.mirColumn==(j+1)){
                  point.fill({
                    value:event.temp,
                    mark:event.mark,
                    gen:Number(event.mirRow)+n,
                    water:event.water,
                    hum:event.hum,
                    waterMark:event.waterMark,
                    humMark:event.humMark,
                  },event.mirRow-1,event.mirRow)
                }
              })
              arr.push(point)
            }
            array=arr.flat(1);
            pointList.push(array)
          }
        }
        item.pointList=pointList;
      })
      this.grainInfo=data;
    }
  }
}
</script>

<style>
  .printHeader{
    font-size: 24px;
    font-weight: 600;
    font-family: '楷体';
    text-align: center;
    height: 50px;
    line-height: 50px;
    border-bottom:4px double
  }
  .printWareTitle{
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    height: 20px;
    line-height: 20px;
    font-family: '楷体'
  }
  .printTable{
    font-size: 12px;
    padding-right: 1px;
    box-sizing: border-box
  }
  .printTableHeader{
    display: flex;
    justify-content: space-between
  }
  .printHang{
    display: flex;
    width: 100%;
    border-left: 1px solid;
    border-top: 1px solid;
    box-sizing: border-box;
  }
  .printHang>div{
    flex-grow: 1;
    flex-basis: 100px;
    text-align: center;
    border-right: 1px solid;
    box-sizing: border-box
  }
  .tableTitle{
    flex-grow: 0 !important;
    flex-basis: 100px !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center
  }
  .printAvgTemp{
    border: 1px solid;
    border-bottom: none;
    box-sizing: border-box
  }
  .printPart{
    display: flex;
  }
  .printPart>div{
    flex-basis: 100px;
    flex-grow: 1;
    border-right: 1px solid;
    text-align: center;
    border-bottom: 1px solid;
    box-sizing: border-box;
  }
  .printPart>div:last-child{
    border-right: none
  }
  .printIdeaInfo{
    text-align: left !important;
    height: 50px;
  }
  .printTips{
    display: flex;
    justify-content: space-between
  }
 
</style>